import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import CardList from '../components/CardList'
import Header from '../components/Header'
import Scroll from '../components/Scroll'
import './App.css'
import ErrorBoundry  from '../components/ErrorBoundry'
import { setSearchField, setCatsList } from '../actions/actions'

const mapStateToProps = state => {
    return {
        searchField: state.searchCat.searchField,
        catsList: state.fetchCatsInfo.catsList,
        isPending: state.fetchCatsInfo.isPending,
        error: state.fetchCatsInfo.error,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSearchChange: (event) => dispatch(setSearchField(event.target.value)),
        fetchCatsList: () => dispatch(setCatsList())
    }
}


const App = (AppProps) => {
    const { onSearchChange, searchField, fetchCatsList, catsList, isPending, error } = AppProps
    
    useEffect(()  => fetchCatsList(), [fetchCatsList])

    const filterCatsList = catsList.filter( cat => cat.name.toLowerCase().includes(searchField.toLowerCase()))

    return (
        <>
            <Header onSearchChange={onSearchChange} />
            <Scroll>
                {
                    isPending ?
                        <h1 className="heading-style-custom tc">Loading</h1> :
                        (
                            error ? 
                                <h1 className="tc">Error: {error}</h1>  : 
                                (   
                                    !catsList.length ?
                                        <h1 className="heading-style-custom tc">There are no cats friends sadly!</h1> :
                                        <ErrorBoundry>
                                            <CardList catsList={filterCatsList} />
                                        </ErrorBoundry>
                                )
                        )
                }
            </Scroll>
        </>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
